module.exports = __webpack_public_path__ + "img/weight3.75904f7b.svg";